export default "__VITE_ASSET__BVfy0Rpb__"